var map = {
	"./de/index.json": [
		672,
		3
	],
	"./en-GB/index.json": [
		673,
		4
	],
	"./es/index.json": [
		674,
		5
	],
	"./fr-FR/index.json": [
		675,
		6
	],
	"./nl/index.json": [
		676,
		7
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 654;
module.exports = webpackAsyncContext;